export enum TabState {
  BeforeSignUp = 'BEFORE_SIGN_UP',
  AfterSignUp = 'AFTER_SIGN_UP',
}

export interface SettingsEvents {
  tabState: TabState;
}
